module.exports = __webpack_public_path__ + "media/images/nav_icons/people-72856a8eb9f5f3bc05af1d5f90d6b796.png";